import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar, DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
interface DatePickerCalendarProps {
  onChange: (event: any) => void;
  defaultValue: any;
}
const DatePickerCalendar: React.FC<DatePickerCalendarProps> = ({
  onChange,
  defaultValue,
}) => {
  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          sx={{ width: '100%' }}
          className="custom-dt-picker-calendar"
          value={dayjs(defaultValue)}
          onChange={onChange}
        />
      </LocalizationProvider>
    </Box>
  );
};
export default DatePickerCalendar;
